module.exports = __webpack_public_path__ + "media/images/components/c01-page-header/psychnet-logo--lg-3765674f909680f7497c9d614bd9bd85.svg";